(function () {
  'use strict';

  // Configurations: (root selector, details selector)
  var CONFIGS = [
    { rootSel: '.header__inline-menu header-menu', detailsSel: 'details.mega-menu' }, // legacy Dawn mega
    { rootSel: '.cz-mega-nav header-menu',         detailsSel: 'details.cz-mega'    }, // Cozzari cz-mega
  ];

  function bind(headerMenu, detailsSel) {
    var details = headerMenu.querySelector(detailsSel);
    if (!details) return;

    var closeTimer = null;

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 120);
    }

    headerMenu.addEventListener('mouseenter', open);
    headerMenu.addEventListener('mouseleave', scheduleClose);
  }

  function initMegaHover() {
    CONFIGS.forEach(function (cfg) {
      var roots = document.querySelectorAll(cfg.rootSel);
      roots.forEach(function (root) { bind(root, cfg.detailsSel); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaHover);
  } else {
    initMegaHover();
  }
})();
